<template >
  <base-material-card v-if="ifEnte" color="secondary" class="mx-5" icon="mdi-bank">
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">
        {{ $t("admin_panel") }}
      </div>
    </template>
    <v-layout class="mx-12">
      <v-tabs v-model="tabs" fixed-tabs background-color="transparent" color="secondary" slider-color="secondary">
        <v-tab class="mr-3" v-if="RBAC_ente_EDIT_ASD_DATA">
          <v-icon class="mr-2">mdi-bank</v-icon>
          {{ $t("associations_management") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_ente_EDIT_CONVENZIONI">
          <v-icon class="mr-2">mdi-handshake-outline</v-icon>
          {{ $t("manage_affiliations_type") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_ente_EDIT_CONVENZIONI">
          <v-icon class="mr-2">mdi-format-list-checkbox</v-icon>
          {{ $t("manage_conventions") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account</v-icon>
          {{ $t("affiliateds") }}
        </v-tab>
         <v-tab class="mr-3" >
          <v-icon class="mr-2">mdi-handshake-outline</v-icon>
          {{ $t("manage_affiliations") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-handshake</v-icon>
          {{ $t("view_affiliation_orders") }}
        </v-tab>
      </v-tabs>
    </v-layout>
    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item v-if="RBAC_ente_EDIT_ASD_DATA">
        <list-associazioni />
      </v-tab-item>
      <v-tab-item v-if="RBAC_ente_EDIT_CONVENZIONI">
        <list-affiliazioni />
      </v-tab-item>
      <v-tab-item v-if="RBAC_ente_EDIT_CONVENZIONI">
        <list-convenzioni />
      </v-tab-item>
      <v-tab-item>
        <list-tesserati />
      </v-tab-item>
      <v-tab-item >
        <edit-affiliazioni
          :title="$t('view_affiliations')"
          type="plain"
          parmsMethod="ENTE"
        />
      </v-tab-item>
      <v-tab-item>
        <list-ordini :card="false" mode="affiliazioni" />
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import listTesserati from "@/app/ente/listTesserati.vue";
import listConvenzioni from "@/app/ente/listConvenzioni.vue";
import listAssociazioni from "@/app/ente/listAssociazioni.vue";
import listAffiliazioni from "@/app/ente/listAffiliazioni.vue";
import listOrdini from "@/widget/listOrdini.vue";
import gestAsdAffiliazioni from "@/app/ente/gestAsdAffiliazioni.vue";

export default {
  name: "ente-admin-panel",
  components: {
    "list-tesserati": listTesserati,
    "list-convenzioni": listConvenzioni,
    "list-ordini": listOrdini,
    "list-associazioni": listAssociazioni,
    "list-affiliazioni": listAffiliazioni,
    "edit-affiliazioni": gestAsdAffiliazioni,
  },

  data() {
    return {
      ifEnte: false,
      tabs: 0,
      RBAC_system_CAN_DEPLOY: false,
      RBAC_ente_EDIT_CONVENZIONI: false,
      RBAC_ente_EDIT_ASD_DATA: false,
    };
  },
  methods: {},
  created() {
    let _ = this;
    _.ifEnte = window.systemData.ifEnte;
    _.RBAC_system_CAN_DEPLOY = _.checkUserRole("system", "CAN_DEPLOY");
    _.RBAC_ente_EDIT_ASD_DATA = _.checkUserRole("ente", "EDIT_ASD_DATA");
    _.RBAC_ente_EDIT_CONVENZIONI = _.checkUserRole("ente", "EDIT_CONVENZIONI");
  },
  watch: {},
};
</script>
